export const langVi = {
    ticketLgy: {
        AuditResult: 'Audit Result',
        ExcepQuestion: 'Abnormal Problems',
        ExcepAnswer: 'Exception Option',
        TicketsTotal: 'Tickets Total',
        Invalid: "Vô hiệu",
        Effected: "Kích hoạt",
        Unblock: "Mở khóa",
        Status: "Trạng thái người dùng",
        Normal: "Bình thường",
        invalid: "Không phù hợp",
        Block: "Khóa",
        Success: "Thành công",
        Failed: "Thất bại",
        TicketTag: "Nhãn vé",
        PartialCompletionTime: "Thời gian hoàn thành một phần",
        GoogleVerification: "Bật xác minh google",
        Active: "Kích hoạt",
        Di: "Vô hiệu",
        Outsourcingornot: "Phân loại nhân viên",
        LocalCollection: "Tự thu",
        Outsourcing: "Ủy ngoại",
        All: "Tất cả",
        PhoneVerify: "gọi điện thoại để xét duyệt",
        plschoose: "làm ơn chọn",
        plsinputID: "làm ơn đầu vào ID",
        ButtonManagement: "Button management",
        ListManagement: "List management",
        Button: "Button",
        Authority: "Authority",
        Add: "Add",
        Edit: "Edit",
        Delete: "Delete",
        RouteList: "Route list",
        addaFirstLevelPage: "新增一级页面",
        Save: "保存",
        AddCallList: "Danh sách cuộc gọi mới",
        ListOrderConfiguration: "Liệt kê cấu hình đơn hàng",
        ListOrder: "Danh sách đơn đặt hàng",
        ListList: "Liệt kê danh sách",
        AutoDial: "Tự động quay số",
        Stop: "Dừng quay số tự động",
        DialID: "Quay số ID",
        QualityInspectionResults: "Kết quả kiểm tra chất lượng",
        QualityInspectionNotes: "Ghi chú kiểm tra chất lượng"
    },

    formLgy: {
        Supplier: "tiếng việt",
        ExtensionNumber: "số máy phụ",
        Name: "họ tên nhân viên",
        RoleList: "danh sách vai trò",
        TicketCategory: "loại hình công việc",
        QueryDimension: "tiến độ kiểm tra",
        Date: "ngày",
        Coupon: "Phiếu mua hàng",
        ButtonSelection: "按钮选择",
        Routing: "路由选择",
        Aging: "Sự lão hóa",
        QueueSorting: "Sắp xếp hàng đợi",
        ListCallOrder: "Liệt kê thứ tự cuộc gọi",       
        orderTags: '标签',
    },
    tableLgy: {
        AverageCallVolume: "Số lần gọi đi trung bình",
        AverageConnectionAmount: "Số lần nhận cuộc gọi trung bình",
        EmployeeRole: "vai trò nhân viên",
        Leader: "trưởng nhóm",
        Groupleader: "phụ nhóm",
        ConnectedRate: "tỷ lệ nghe máy",
        CallMedian: "Số trung bình của cuộc thoại",
        RegistrationTime: "đăng ký thời gian",
        LastLoginTime: "Lần đăng nhập cuối cùng",
        PageName: "Page name",
        ButtonBame: "Button name",
        RouteName: "Route name",
        Route: "路由",
        Value: "Value",
        AutoCall: "Auto Call",
        ManualCall: "Manual Call",
        CallMode: "Call Mode"
    },
    menuLgy: {
        ResultStatistics:'Thống kê báo cáo kết quả nhắc nhở',
        CallRecordData: "bảng báo cáo thống kê dữ liệu gọi đi",
        CollectionPerformanceDetails: "Thông tin chi tiết về hiệu suất bộ sưu tập",
        SelectCouponTemplate: "Vui lòng chọn một mẫu phiếu giảm giá",
        PageManagement: "Page management",
        RouteManagement: "Route management",
        MenuList: "菜单列表",
        MenuDetails: "菜单详情",
        CallSequenceConfiguration: "呼叫顺序配置"
    },
    tipsLgy: {
        EnterPageName: "Please enter the page name",
        EnterRouteName: "Please enter the route name",
        ConfirmDelete: "Confirm delete",
        EnterRouteValue: "Please enter the route value",
        SelectButton: "请选择按钮",
        SelectRoute: "请选择路由",
        CallSequenceConfiguration: "Cấu hình trình tự cuộc gọi",
        EnterNumber: "Vui lòng nhập một số, số, số...",
        NotPTPAndNextCallTime: "Please do not fill in PTP time and Next call time simultaneously",
        NextCallTimeTips: "If already saved PTP , please do not fill this content"
    }
};
